module.exports = __webpack_public_path__ + "assets/img/banner2.66f40c77.png";